import React, { Component } from 'react';
import { bindActionCreators } from 'redux'
import Dropzone from 'react-dropzone';
import { connect } from "react-redux";
import './index.scss';

import { addDropzoneFiles } from '../actions/dlaactions'

class DropArea extends Component {
  constructor() {
    super();
    this.onDrop = (files) => {
      this.props.addDropzoneFiles(files);
    };

  }

  render () {
    return (
      <Dropzone onDrop={this.onDrop}>
        {({ getRootProps, getInputProps }) => (

          <div {...getRootProps({ className: 'dropzone' })}>
            <input {...getInputProps({ id: 'upload-input' })} />
            <p>Drag & Drop or Click here to queue files for import. Max file limit is {this.props.maxLimit} and Max row limit per file is {this.props.maxRowLimit}.</p>
          </div>

        )
        }

      </Dropzone>

    );
  }
}

const mapStateToProps = state => ({
  data: state.gCache.data
});

const mapDispatchToProps = dispatch => bindActionCreators({

  addDropzoneFiles

}, dispatch);
export default React.memo(connect(
  mapStateToProps,
  mapDispatchToProps
)(DropArea));





